(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-chart-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    const openButton = event.target.closest('[data-size-chart-open]');
    if (openButton) {
      const dialog = document.getElementById(openButton.dataset.sizeChartOpen);
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }

    const closeButton = event.target.closest('[data-size-chart-close]');
    if (closeButton) {
      const dialog = document.getElementById(closeButton.dataset.sizeChartClose);
      if (dialog) dialog.close();
      return;
    }

    const dialog = event.target.closest('.size-chart__dialog');
    if (dialog && event.target === dialog) dialog.close();
  });
  } catch(e) { console.error(e); }
})();

})();
